import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  IonHeader,
  IonContent,
  IonToolbar,
  IonButton,
  IonTitle,
  IonPage,
  IonCard,
  IonCardHeader,
  IonItem,
  IonIcon,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";

import { calendarOutline, closeCircle } from "ionicons/icons";

import {
  Button,
  Popover,
  Tabs,
  Avatar,
  Typography,
  Badge,
  Tag,
  Grid,
  Row,
  Col,
  Empty,
  Skeleton,
  Divider,
  message,
} from "antd";
import {
  FieldTimeOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  SettingFilled,
  CaretRightOutlined,
} from "@ant-design/icons";

/* Global State*/ 
import useAuthStore from "../states/useAuth";
import useGeneralStore from "../states/useGeneral";


import c from "../utils/common";
import moment from "moment-timezone";
import axios from "axios";
import Footer from "../components/footer";
import metaData from "../data/metaData";
import { style } from "../css/css";
import ScrollContainer from "react-indiana-drag-scroll";

import { useTranslation } from "react-i18next";

const { useBreakpoint } = Grid;
const { Paragraph } = Typography;
const { TabPane } = Tabs;
let globalState = undefined;
const Home = () => {
  const {auth, user} = useAuthStore();
  const {changeLanguage} = useGeneralStore();
  const history = useHistory();
  let currentPath = window.location.pathname;
  const [firstRender, setFirstRender] = useState(true);
  const screens = useBreakpoint();

  const [vendors, setVendors] = useState();
  const [request, setRequest] = useState();
  const [AdminShow, setAdminShow] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [loading_invitation_response, setLoading_invitation_response] =
    useState(false);

  //Invitation
  const [invitations, setInvitations] = useState([]);

  const { t, i18n } = useTranslation();

  const key = "updatable";

  async function loadLatestData() {
    let query = `?docType=${user?.docType}`;
    const res = await axios.get(metaData.serverURL + "getWebsiteAccountData" + query, {
      headers: { Authorization: auth.jwt },
    });
    console.log(res);
    if (res.data.status == "Success") {
      let {
        user,
        vendors,
        requests,
        create_assistant_requests,
        reports,
        tickets,
        invitations,
        today,
        refreshToken,
      } = res.data;

      // globalActions.refreshAccountData({
      //   user,
      //   vendors,
      //   requests,
      //   create_assistant_requests,
      //   reports,
      //   tickets,
      //   invitations,
      //   today,
      //   auth: { passed: true, jwt: refreshToken },
      // });

      filterLastestDataForDisplay(vendors, requests, invitations);
    }
  }

  function filterLastestDataForDisplay(vendors, requests, invitations) {
    // vendors = globalGetters.approvedBeforeVendor(null, { vendors, requests });
    // requests = globalGetters.pendingRequest(null, { requests });

    // //console.log(vendors)

    // setVendors(vendors);
    // setRequest(requests);
    // setInvitations(invitations);
    // setLoadingData(false);
  }

  function logOut() {
    // globalActions.logOut();
    history.push("/login");
  }

  const acceptInvitation = async (invitationId, accepted) => {
    setLoading_invitation_response(true);

    const data = { invitationId, accepted };
    console.log(data);
    const res = await axios.post(
      globalState.serverURL + "admin/invitation/accept",
      data,
      { headers: { Authorization: globalState.auth.jwt } }
    );
    console.log(res);

    if (res.data.status == "Error") {
    } else if (res.data.status == "Success") {
      message.success({ content: "Accepted invitation", key, duration: 5 });

      loadLatestData();

      //remove current invitation from list before global state updated, to prevent double-spending problem
      setInvitations([...invitations].filter((e) => e.id != invitationId));
      setLoading_invitation_response(false);
    }
  };

  const rejectInvitation = async (invitationId, rejected) => {
    setLoading_invitation_response(true);
    const data = { invitationId, rejected };
    console.log(data);
    const res = await axios.post(
      globalState.serverURL + "admin/invitation/reject",
      data,
      { headers: { Authorization: globalState.auth.jwt } }
    );
    console.log(res);

    if (res.data.status == "Error") {
    } else if (res.data.status == "Success") {
      message.success({ content: "Rejected invitation", key, duration: 5 });

      loadLatestData();

      //remove current invitation from list before global state updated, to prevent double-spending problem
      setInvitations([...invitations].filter((e) => e.id != invitationId));
      setLoading_invitation_response(false);
    }
  };

  /**
   * Render Component
   */

  const renderInvitationList = () => {
    console.log(invitations);
    return invitations?.length > 0 ? (
      <ScrollContainer
        hideScrollbars={false}
        vertical={true}
        horizontal={false}
        style={{
          height: 500,
        }}
        className="show-scroll-bar-on-hover custom-scrollbar"
      >
        <Row style={{ width: 325 }}>
          {invitations?.map((invitation, i) => (
            <div key={i} style={{ width: 300 }}>
              <a style={{ fontSize: 16, fontWeight: "bolder", width: 300 }}>
                {invitation.event?.name}
              </a>
              <div style={{ color: style.gray3 }}>
                <FieldTimeOutlined />
                &nbsp;
                {moment(invitation.event?.time?.start).format("YYYY-MM-DD")}
              </div>

              <Paragraph
                style={{
                  fontSize: 14,
                  width: 300,
                  margin: "0 0 12 0",
                  whiteSpace: "no-wrap",
                }}
                ellipsis={{
                  rows: 2,
                  expandable: true,
                }}
              >
                {invitation.event?.description}
              </Paragraph>

              <Button
                disabled={loading_invitation_response}
                onClick={() => {
                  acceptInvitation(
                    invitation.id,
                    invitation.invited.map((e) => e.id)
                  );
                }}
                type="primary"
              >
                accept
              </Button>
              <Button
                disabled={loading_invitation_response}
                onClick={() => {
                  rejectInvitation(
                    invitation.id,
                    invitation.invited.map((e) => e.id)
                  );
                }}
                style={{ marginLeft: 24 }}
                type="danger"
              >
                reject
              </Button>

              <Divider />
            </div>
          ))}
        </Row>
      </ScrollContainer>
    ) : (
      <Empty description="No invitation" />
    );
  };

  const ChangePassword = () => {
    return (
      <Button
        type="text"
        onClick={() => {
          history.push("/changePassword");
        }}
      >
        {t("home.ChangePassword")}
      </Button>
    );
  };

  useEffect(() => {
    if (currentPath == "/home") {
      //console.log(currentPath + '...')
      if (firstRender == true) {
        setFirstRender(false);
        loadLatestData();
      }
    }
  }, [window.location.pathname]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          {/* <IonButtons slot="end">
            <div onClick={() => { setAdminShow(!AdminShow); }} style={{ maxHeight: "50px", maxWidth: "50px" }}>
              <Avatar size={40} icon={<UserOutlined />} />
            </div>
          </IonButtons> */}

          <Row slot="end" style={{ cursor: "pointer" }}>
            {/* <Badge count={globalState?.invitations?.length}>
              <Popover placement="bottom" title={<div style={{ fontSize: 18 }}>邀請</div>} content={renderInvitationList()} trigger="click">
                <IonIcon style={{ fontSize: 24}} icon={notifications}></IonIcon>
              </Popover>
            </Badge> */}

            <Popover
              placement="bottom"
              content={ChangePassword()}
              trigger="click"
            >
              <SettingFilled
                style={{ fontSize: 24, marginLeft: 30, marginRight: 30 }}
              />
            </Popover>
          </Row>

          <Row
            slot="end"
            align="middle"
            style={{
              minWidth: 200,
              marginLeft: 24,
              marginRight: 12,
              border: "1px solid #CDCDCD",
              borderRadius: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              console.log(globalState);
            }}
          >
            <Col span={6}>
              <Avatar size={40} icon={<UserOutlined />} />
            </Col>
            <Col span={18}>
              <Row
                justify="center"
                align="middle"
                style={{
                  minWidth: 75,
                  height: 30,
                  borderRadius: 1000,
                  backgroundColor: style.gray1,
                }}
              >
                {globalState?.user?.docType}
              </Row>

              <Paragraph
                style={{
                  width: "100%",
                  textAlign: "center",
                  margin: 0,
                }}
                ellipsis={{
                  rows: 1,
                }}
              >
                {globalState.user.email}
              </Paragraph>
            </Col>
          </Row>

          <IonTitle
            onClick={() => {
              //console.log(globalState)
            }}
          >
            <img
              style={{ width: "30px", height: "30px", borderRadius: "5px" }}
              src={
                metaData.blobPreURL +
                metaData.appLogoPath +
                metaData.blobPostURL
              }
            ></img>
            <strong style={{ marginLeft: "5px" }}>
              {t("home.titletext")}&nbsp;
              {metaData.environment == "test" ? <Badge count={"test"} /> : null}
            </strong>
          </IonTitle>

          <IonButton
            style={{ marginLeft: 20 }}
            onClick={() => {
              logOut();
            }}
            slot="end"
          >
            {t("home.Logout")}
          </IonButton>
        </IonToolbar>
        {AdminShow ? (
          <IonToolbar>
            {globalState.user ? (
              <ion-grid>
                <ion-row>
                  <ion-col span={3}>
                    {" "}
                    {t("home.name")}:{" "}
                    {globalState.user.name ? globalState.user.name : "--"}{" "}
                  </ion-col>
                  <ion-col span={2}>
                    {" "}
                    {t("home.nickname")}:{" "}
                    {globalState.user.nickname
                      ? globalState.user.nickname
                      : "--"}
                  </ion-col>
                  <ion-col span={2}>
                    {" "}
                    {t("home.phone")}:{" "}
                    {globalState.user.tel ? globalState.user.tel : "--"}
                  </ion-col>
                  <ion-col span={2}>
                    {" "}
                    {t("home.email")}:{" "}
                    {globalState.user.email ? globalState.user.email : "--"}
                  </ion-col>
                </ion-row>
              </ion-grid>
            ) : null}
            <ion-button
              slot="end"
              onClick={() => {
                setAdminShow(false);
              }}
            >
              <IonIcon icon={closeCircle} />
            </ion-button>
          </IonToolbar>
        ) : null}
      </IonHeader>

      <IonContent>
        <div style={{ margin: "5% 10% 0 10%" }}>
          {/* Event */}
          <IonCard
            style={{ cursor: "pointer", width: "20%", marginBottom: 30 }}
            onClick={() => {
              history.push("/event");
            }}
          >
            <Row align="middle">
              <Col span={2}></Col>
              <Col span={4}>
                <IonIcon style={{ fontSize: 30 }} icon={calendarOutline} />
              </Col>
              <Col span={18}>
                <IonCardHeader>
                  {t("home.AllEvent")}{<CaretRightOutlined />}
                </IonCardHeader>
              </Col>
            </Row>
          </IonCard>

          {loadingData == true ? (
            <Skeleton active />
          ) : (
            <>
              {/* Tab */}
              <Tabs
                size="large"
                defaultActiveKey="已驗證商戶"
                tabBarExtraContent={{
                  right: (
                    <IonButton
                      onClick={() => {
                        history.push("/requests/new-vendor");
                      }}
                    >
                      {t("home.NewVendor")}
                    </IonButton>
                  ),
                }}
              >
                <TabPane
                  tab={
                    <div>
                      {t("home.ApprovedMer")} ({vendors ? vendors.length : 0})
                    </div>
                  }
                  key="已驗證商戶"
                >
                  <Row gutter={14}>
                    {vendors && vendors.length > 0 ? (
                      vendors.map((vendor, i) => (
                        <Col key={i} xs={24} md={12} lg={8} margin={50}>
                          <IonCard
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              // globalActions.activeId("vendor", vendor.id);
                              // let activeRequest =
                              //   globalGetters.getRequestByVendorId(
                              //     globalState,
                              //     vendor.id
                              //   );
                              // globalActions.activeId(
                              //   "request",
                              //   activeRequest.id
                              // );
                              // history.push("/dashboard");
                            }}
                          >
                            <Row>
                              <Col span={5}>
                                <img
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "5px",
                                    margin: "12px 0 12px 12px",
                                  }}
                                  src={
                                    metaData.blobPreURL +
                                    "clientUpload-" +
                                    vendor.logo +
                                    ".jpeg" +
                                    metaData.blobPostURL
                                  }
                                ></img>
                              </Col>
                              <Col span={13}>
                                <IonCardHeader>
                                  <Paragraph
                                    style={{
                                      color: "black",
                                      fontSize: 20,
                                      margin: "0px",
                                    }}
                                    ellipsis={{
                                      rows: 1,
                                    }}
                                  >
                                    {vendor.name}
                                  </Paragraph>

                                  <Paragraph
                                    style={{ color: "gray", margin: "0px" }}
                                    ellipsis={{
                                      rows: 1,
                                    }}
                                  >
                                    {globalState.language == "chn"
                                      ? vendor.needReview
                                        ? `驗證中`
                                        : vendor.approvedTime == null
                                        ? `已驗證`
                                        : `驗證於 ${moment(
                                            vendor.approvedTime
                                          ).format("YYYY年M月DD日")}`
                                      : "en"
                                      ? vendor.needReview
                                        ? `Processing`
                                        : vendor.approvedTime == null
                                        ? `Approved Shop`
                                        : `Valid from ${moment(
                                            vendor.approvedTime
                                          ).format("YYYY/MM/DD")}`
                                      : console.log("language undifine")}
                                  </Paragraph>
                                </IonCardHeader>
                              </Col>
                              <Col span={6} style={{ textAlign: "end" }}>
                                {vendor.isShow == false ? (
                                  <Tag style={{ marginTop: 10 }} color="red">
                                    <EyeInvisibleOutlined />
                                    {t("home.hidden")}
                                  </Tag>
                                ) : null}
                                {vendor.needReview ? (
                                  <Tag
                                    style={{ marginTop: 10 }}
                                    color="warning"
                                  >
                                    {t("home.Unapprove")}
                                  </Tag>
                                ) : null}
                              </Col>
                            </Row>
                          </IonCard>
                        </Col>
                      ))
                    ) : (
                      <Empty description={t("home.NA")}></Empty>
                    )}
                  </Row>
                </TabPane>

                <TabPane
                  tab={
                    <div>
                      {t("home.NewApplication")} ({request ? request.length : 0}
                      )
                    </div>
                  }
                  key="新商戶申請"
                >
                  <Row gutter={14}>
                    {request && request.length > 0 ? (
                      request.map((request) => (
                        <Col
                          key={request.id}
                          xs={24}
                          md={12}
                          lg={8}
                          margin={50}
                        >
                          <IonCard
                            style={{ cursor: "pointer" }}
                            key={request.id}
                            onClick={() => {
                              // globalActions.activeId("request", request.id);
                              // history.push("/requests/detail");
                            }}
                          >
                            <Row>
                              <Col span={5}>
                                <img
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "5px",
                                    margin: "12px 0 12px 12px",
                                  }}
                                  src={
                                    metaData.blobPreURL +
                                    "clientUpload-" +
                                    request.info.logo +
                                    ".jpeg" +
                                    metaData.blobPostURL
                                  }
                                ></img>
                              </Col>
                              <Col span={19}>
                                <IonCardHeader>
                                  <Paragraph
                                    style={{
                                      color: "black",
                                      fontSize: 20,
                                      margin: "0px",
                                    }}
                                    ellipsis={{
                                      rows: 1,
                                    }}
                                  >
                                    {request.info.name}
                                  </Paragraph>
                                  <Paragraph
                                    style={{ color: "gray", margin: "0px" }}
                                    ellipsis={{
                                      rows: 1,
                                    }}
                                  >
                                    {globalState.language == null &&
                                    globalState.language == "chn"
                                      ? `於 ${moment(request.createTime).format(
                                          "YYYY年M月DD日"
                                        )} 提交申請`
                                      : "en"
                                      ? `Applied on ${moment(
                                          request.createTime
                                        ).format("YYYY/MM/DD")} `
                                      : console.log("language undifine")}
                                  </Paragraph>
                                </IonCardHeader>
                              </Col>
                            </Row>
                          </IonCard>
                        </Col>
                      ))
                    ) : (
                      <Empty description={t("home.NA")}></Empty>
                    )}
                  </Row>
                </TabPane>
              </Tabs>
              <div style={{ paddingTop: "10%" }}></div>
            </>
          )}
        </div>

        {/* <div style={{ padding: "5% 10% 0 10%", background: "#E8E8E8" }}>

          <Row>
            <strong style={{ fontSize: 20 }}>新商戶申請︰</strong>
          </Row>

          {loadingData == true ?
            <Skeleton active />
            :
            <Row gutter={14} style={{ background: "#E8E8E8", margin: 0, padding: 0 }}>
              {request && request.length > 0 ?
                request.map(request => (
                  <Col key={request.id}
                    xs={24}
                    md={12}
                    lg={8}
                    margin={50}
                  >
                    <IonCard style={{ cursor: "pointer" }} key={request.id}
                      onClick={() => {
                        globalActions.activeId("request", request.id);
                        history.push('/requests/detail')
                      }}
                    >
                      <IonItem >
                        <img style={{ width: "60px", height: "60px", borderRadius: "5px" }} src={metaData.blobPreURL + "clientUpload-" + request.info.logo + ".jpeg" + metaData.blobPostURL}></img>
                        <IonCardHeader>
                          <IonCardTitle>{request.info.name}</IonCardTitle>
                          <IonCardSubtitle>於 {moment(request.createTime).format("YYYY年M月DD日")} 提交申請</IonCardSubtitle>
                        </IonCardHeader>
                      </IonItem>
                    </IonCard>
                  </Col>
                ))
                :
                <Empty description={"暫無"}></Empty>
              }
            </Row>
          }


          <div style={{ paddingTop: "10%" }}></div>


        </div> */}
        <Row justify="end">
          <IonItem style={{ width: "10%", margin: "0% 10% 5% 10%" }}>
            <IonLabel>{t("home.language")}</IonLabel>
            <IonSelect
              value={globalState.language}
              onIonChange={(e) => {
                changeLanguage(e.detail.value);
              }}
            >
              <IonSelectOption value="chn">中文</IonSelectOption>
              <IonSelectOption value="en">English</IonSelectOption>
            </IonSelect>
          </IonItem>
        </Row>
      </IonContent>

      <Footer />
    </IonPage>
  );
};

export default Home;
